import React, { Component } from 'react';
import CargomaticCard from 'components/v2/card';
import DataPoller from 'components/ui/DataPoller';
import AuditHistory from 'components/modules/shipments/AuditHistory';
import CustomersAPIUtils from 'utils/CustomersAPIUtils';
import { withTranslation } from 'react-i18next';

const POLLING_FREQ = 15000;

class RecentActivity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      audits: [],
    };
  }

  getRecentActivity = async () => {
    const { email } = this.props;
    const audits = await CustomersAPIUtils.getRecentActivityByEmail(email);
    if (audits && audits.length) this.setState({ audits });
  };

  componentDidMount() {
    this.getRecentActivity();
  }

  render() {
    const { audits } = this.state;
    const hasAudits = audits && audits.lenght;
    const { t } = this.props;
    return (
      <CargomaticCard header={() => <h3>{t('RECENT_ACTIVITY')}</h3>}>
        <DataPoller action={this.getRecentActivity} frequency={POLLING_FREQ} />
        {hasAudits && (
          <div className="card--no-x-padding card--no-top-padding">
            <AuditHistory audits={audits} paginate />
          </div>
        )}
        {!hasAudits && (
          <span className="text-grey-dark">{t('NO_RECENT_ACTIVITY')}</span>
        )}
      </CargomaticCard>
    );
  }
}

export default withTranslation()(RecentActivity);
